import { useTranslation } from '@multaqa/i18n'
import { ConfirmDialog } from '@multaqa/ui/components/ui/confirm-dialog'
import { useDeactivateSupplier } from '../hooks/use-suppliers'

export function SupplierDeactivateDialog({
  supplierId,
  supplierCode,
  open,
  onOpenChange,
}: {
  supplierId: string
  supplierCode: string
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const { t } = useTranslation()
  const deactivate = useDeactivateSupplier()

  const handleDeactivate = () => {
    deactivate.mutate(supplierId, {
      onSuccess: () => {
        onOpenChange(false)
      },
    })
  }

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('supplier.deactivate')}
      description={t('supplier.deactivateConfirmation', { code: supplierCode })}
      confirmLabel={t('supplier.deactivate')}
      cancelLabel={t('action.cancel')}
      closeLabel={t('action.cancel')}
      tone="destructive"
      pending={deactivate.isPending}
      onConfirm={handleDeactivate}
      testId="supplier-deactivate-dialog"
    />
  )
}
